module.exports = __webpack_public_path__ + "img/link.8bafb019.svg";